import styled from 'styled-components';

export const Content = styled.div``;

export const Detail = styled.div`
  display: flex;
  flex-direction: column;
`;

/* The gap between the two field pairs. `FieldPair` already carries the
   inter-column gap; this is the row rhythm between them. */
export const Rows = styled.div`
  height: var(--s4);
`;
